<mat-sidenav-container class="full-height" hasBackdrop="false">
    <mat-sidenav id="app-menu" mode="over" position="start" [opened]="layoutService.isNavigationOpen()">
        <navigation></navigation>
    </mat-sidenav>

    <mat-sidenav id="notifications-menu" mode="over" position="end" [opened]="layoutService.isNotificationOpen()">
        <notification></notification>
    </mat-sidenav>

    <mat-sidenav-content id="main">
        <arcus-toolbar (logout)="logout()"></arcus-toolbar>
        <router-outlet></router-outlet>
    </mat-sidenav-content>
</mat-sidenav-container>
